import { FC } from "react";
import Skeleton from "@mui/material/Skeleton";
import IconCheckCSvg from "../../../assets/svg-fc/IconCheckCSvg";
import { iNotificationFilter } from "../../../types/notificationTypes";
import "./notificationStates.scss";

export const NotificationEmptyState: FC<{ filter: iNotificationFilter }> = ({ filter }) => {
	const isFiltered = !!filter.category || filter.unreadOnly;
	return (
		<div className="notification_empty_state">
			<span className="notification_empty_state_icon">
				<IconCheckCSvg />
			</span>
			<strong>{isFiltered && !filter.unreadOnly ? "Nothing here yet" : "You're all caught up"}</strong>
			<p>New notifications about your events will show up here.</p>
		</div>
	);
};

export const NotificationLoadError: FC<{ onRetry: () => void }> = ({ onRetry }) => (
	<div className="notification_empty_state">
		<strong>Notifications didn't load</strong>
		<p>Check your connection and try again.</p>
		<button type="button" className="notification_empty_state_retry" onClick={onRetry}>
			Try again
		</button>
	</div>
);

export const NotificationRowsSkeleton: FC<{ rows?: number; size?: "compact" | "large" }> = ({
	rows = 4,
	size = "compact",
}) => (
	<div className={`notification_rows_skeleton notification_rows_skeleton_${size}`}>
		{Array.from({ length: rows }, (_, index) => (
			<div key={index} className="notification_rows_skeleton_row">
				<Skeleton variant="circular" className="notification_rows_skeleton_icon" />
				<div className="notification_rows_skeleton_body">
					<Skeleton variant="text" width="45%" />
					<Skeleton variant="text" width="75%" />
					<Skeleton variant="text" width="90%" />
				</div>
			</div>
		))}
	</div>
);
